import React from 'react';
import CreateIconComponent, {
  CreateIconComponentProps,
} from '@zola/zola-ui/src/components/SvgIcons/CreateIconComponent';

export const ChevronDown: React.FC<CreateIconComponentProps> = props => (
  <CreateIconComponent viewBox="0 0 24 24" {...props}>
    <path
      d="M6 9L12 15L18 9"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </CreateIconComponent>
);
